import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ExoStar } from 'src/app/models/ExoStar';
import { Observable } from 'rxjs';
import { configuration } from 'src/environments/environment';
import { IAttributes } from 'src/app/models/IAttributes';
import { ExostarTransaction } from 'src/app/models/ExoStarTransaction';
import { EXOAuthTransaction } from 'src/app/models/EXOAuthTransaction';
import { ILogicalAudit } from 'src/app/models/ilogical-audit';
import { IEpcsRxAuditLog } from 'src/app/models/IEpcsRxAuditLog';
import { Iauditlog } from 'src/app/models/iauditlog.model';
import { IXMLauditLogs } from 'src/app/ixmlaudit-logs.model';

@Injectable({
  providedIn: 'root'
})
export class ExoStarService {

  constructor(private http: HttpClient) { }

  // Insert exostar user details
  insertExoStarUserDetails(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/ExoStarUser'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update exostar user license key details
  updateExoStarUserLicenseKey(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/LicenseKey'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update exostar user activation code details
  updateExoStarUserActivationCode(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/ActivationCode'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //get dashboard details
  GetExoStarDashboardDetails(userid: string, role: string): Observable<ExoStar[]> {
    const posteddata = {
      userid: userid,
      role: role,
      facilityId: sessionStorage.getItem("FacilityId"),

    }
    return this.http.post<ExoStar[]>(`${configuration.clinicapiUrl + 'ExoStar/GetExostardashboards'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  insertExoStarLicencesDetails(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/InsertExostarLicences'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update exostar user licences details
  updateExoStarLicencesdetails(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/UpdateExostarLicences'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  insertExoStarAvailedLicencesDetails(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/InsertExostarAvailedLicences'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update exostar user license Availed details
  updateExoStarAvailedLicencesDetails(exoStarUserInfo: ExoStar): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/UpdateExostarAvailedLicences'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getExoStarLicencesdetails(): Observable<ExoStar[]> {
    return this.http.get<ExoStar[]>(`${configuration.clinicapiUrl + 'ExoStar/GetExostarLicences'}?facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  deleteLicencesRecord(licid: number): any {
    return this.http.post<any>(`${configuration.clinicapiUrl + 'ExoStar/DeletemanageLincense'}?licid=${licid}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getExoStarDetails(userId): Observable<ExoStar> {
    return this.http.get<ExoStar>(`${configuration.clinicapiUrl + 'ExoStar/GetExostarUserbyId'}?userid=${encodeURIComponent(userId.toString())}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  manageExoStarDetails(userId): Observable<ExoStar> {
    return this.http.get<ExoStar>(`${configuration.clinicapiUrl + 'ExoStar/GetExoStar'}?userid=${encodeURIComponent(userId.toString())}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  getAttributes(type: string): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'ExoStar/Attributes'}?type=${type}`);
  }

  initiateProofing(userId): Observable<ExostarTransaction> {
    const posteddate = {
      userid: encodeURIComponent(userId.toString()),
      facilityid: sessionStorage.getItem("FacilityId"),
      loggedInUser: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/initiateProofing'}`, posteddate, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  resumeProofing(exoStarUserInfo: ExoStar): Observable<ExostarTransaction> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/ResumeProofing'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getNavigateUrl(FacilityId: number): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'ExoStar/getNavigateUrl'}?facilityId=${FacilityId}`);
  }

  initiateWebProofing(userId): Observable<ExostarTransaction> {
    const posteddata = {
      userid: userId,
      facilityid: sessionStorage.getItem("FacilityId"),
      loggedInUser: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    // return this.http.get<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/initiatewebcamProofing'}?userid=${encodeURIComponent(userId.toString())}&&facilityid=${sessionStorage.getItem("FacilityId")}&&loggedInUser=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/initiatewebcamProofing'}`, posteddata);
  }

  getScheduleWebCamNavigateUrl(FacilityId: number): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'ExoStar/getSchedulewebCameTradeUrl'}?facilityId=${FacilityId}`);
  }
  getMasterData(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/MasterDataByType'}?loggedUser=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  TwoFactorAUthenticationDetails(exoStarUserInfo: ExoStar): Observable<ExoStar[]> {
    const posteddata = {
      inputdata: JSON.stringify(exoStarUserInfo)
    }
    return this.http.post<ExoStar[]>(`${configuration.clinicapiUrl + 'ExoStar/TwoFactorAUthentication'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateExoStarProviderGrantAccessdetails(userId: string, providerGrantaccess: boolean): Observable<string> {
    const posteddata = {
      userid: userId,
      providerGrantAccess: providerGrantaccess,
      facId: sessionStorage.getItem("FacilityId"),
      locId: sessionStorage.getItem("LocationId")
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/ProviderGrantAccess'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // checkPushTransactionStatus(transRefId : string ): Observable<ExostarTransaction> {
  //   return this.http.get<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/pushStatus'}?transRefId=${transRefId}`);
  // }

  checkPushTransactionStatus(trans: EXOAuthTransaction): Observable<ExostarTransaction> {
    const posteddata = {
      inputdata: JSON.stringify(trans)
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/pushStatus'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  clearPushTransaction(transRefId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'ExoStar/clearpushStatus'}?transRefId=${transRefId}`);
  }

  DeactiveexostarUsers(comment: string, providerId: string): Observable<ExostarTransaction> {
    const posteddata = {
      comment: comment,
      providerId: encodeURIComponent(providerId.toString()),
      facilityId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/DeactivateexostarUsers'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  launchSession(transaction: EXOAuthTransaction): Observable<ExostarTransaction> {
    const posteddata = {
      inputdata: JSON.stringify(transaction)
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/GetLaunchSession'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateExostardefaultOptionDetails(userId: string, token: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/defaultOption'}?userId=${encodeURIComponent(userId.toString())}&&token=${token}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetExoStarOptionsDetails(userId: string): Observable<IAttributes> {
    return this.http.get<IAttributes>(`${configuration.clinicapiUrl + 'ExoStar/GetExostardefaultOption'}?userId=${encodeURIComponent(userId.toString())}`);
  }

  insertErxAuditLogDetails(LAuditObj: ILogicalAudit): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(LAuditObj)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/insertErxAuditLog'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getExoStarAssociateDetails(userId): Observable<ExoStar> {
    return this.http.get<ExoStar>(`${configuration.clinicapiUrl + 'ExoStar/GetAssociateUser'}?userId=${encodeURIComponent(userId.toString())}`);
  }

  searchErxAuditLogDetails(provider: string, admin: string, ToDate: string, FromDate: string): Observable<ILogicalAudit[]> {
    const posteddata = {
      provider: provider,
      admin: admin,
      ToDate: ToDate,
      FromDate: FromDate
    }
    // return this.http.get<ILogicalAudit[]>(`${configuration.clinicapiUrl + 'ExoStar/searchErxAuditLog'}?provider=${encodeURIComponent(provider.toString())}&&admin=${encodeURIComponent(admin.toString())}&&ToDate=${ToDate}&&FromDate=${FromDate}`);
    return this.http.post<ILogicalAudit[]>(`${configuration.clinicapiUrl + 'ExoStar/searchErxAuditLog'}`, posteddata);
  }

  UpdateMessingSendbyId(senderid: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/UpdateMessagingsendbysenderId'}?senderid=${senderid}&&locId=${Number(sessionStorage.getItem("LocationId"))}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  InitiateRevoke(userId: string, revokeAdminUser: string, grantAccess: boolean): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/UpdateinitiateRevokebyuserId'}?userid=${encodeURIComponent(userId.toString())}&&RevokeadminUser=${encodeURIComponent(revokeAdminUser.toString())}&&grantAccess=${grantAccess}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  finalizeRevoke(userId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'ExoStar/FinalizeRevoke'}?userId=${encodeURIComponent(userId.toString())}`);
  }

  searchEPCSRxAuditLogDetails(patientName: string, drug: string, providerName: string, toDate: string, fromDate: string, prescriptionStatus: string): Observable<IEpcsRxAuditLog[]> {
    const posteddata = {
      patientName: patientName,
      drug: drug,
      providerName: providerName,
      toDate: toDate,
      fromDate: fromDate,
      prescriptionStatus: prescriptionStatus,
      facilityId: sessionStorage.getItem("FacilityId")
    }
    // return this.http.get<IEpcsRxAuditLog[]>(`${configuration.clinicapiUrl + 'ExoStar/searchEPCSRxAuditLog'}?patientName=${patientName}&&drug=${drug}&&providerName=${providerName}&&toDate=${toDate}&&fromDate=${fromDate}&&prescriptionStatus=${prescriptionStatus}`);
    return this.http.post<IEpcsRxAuditLog[]>(`${configuration.clinicapiUrl + 'ExoStar/searchEPCSRxAuditLog'}`, posteddata);
  }
  AuditLogs_TransformXMLWithXSLT(logid: number, type: string) {
    const logidstr = logid.toString();
    return this.http.get<any>(`${configuration.clinicapiUrl + 'ExoStar/AuditLogs_TransformXMLWithXSLT'}?id=${logidstr}&&type=${type}&&facilityId=${sessionStorage.getItem("FacilityId").toString()}`);
  }
  searchAuditLogDetails(userid: string, patientid: string, screenName: string, fromDate: string, toDate: string, locations: string, pagenumber: any): Observable<Iauditlog[]> {
    const posteddata = {
      userid: userid,
      patientid: patientid,
      screenName: screenName,
      toDate: toDate,
      fromDate: fromDate,
      locations: locations,
      facilityId: sessionStorage.getItem("FacilityId"),
      pagenumber: pagenumber
    }
    return this.http.post<Iauditlog[]>(`${configuration.clinicapiUrl + 'ExoStar/searchAuditLog'}`, posteddata);
  }
  AuditLogScreenNamesDetails(): Observable<Iauditlog[]> {
    return this.http.get<Iauditlog[]>(`${configuration.clinicapiUrl + 'ExoStar/AuditLogScreenNames'}`);
  }
  updateExostarPrescriptionDetails(userId: string, prescription: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/MaxPrescriptionLimit'}?userId=${encodeURIComponent(userId.toString())}&&prescription=${prescription}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  xmlAuditLogDetails(id: string, actiontype: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'ExoStar/XMLAuditLog'}?id=${id.toString()}&&actiontype=${actiontype.toString()}&&facilityId=${sessionStorage.getItem("FacilityId").toString()}`);
  }
  GetRxAuditLogDetails(drug: string, toDate: string, fromDate: string): Observable<IEpcsRxAuditLog[]> {
    const posteddata = {
      drug: drug,
      toDate: toDate,
      fromDate: fromDate
      , facilityId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IEpcsRxAuditLog[]>(`${configuration.clinicapiUrl + 'ExoStar/RxAuditLog'}`, posteddata);
  }
}
